import {createInstance as createInstanceMapped} from '../pano/mappedPano'
import {addChild} from '../util'
import '../util/cache'
import '../util/webapp'
import '../../style/screen.scss'

/**
 * Export the instance
 * @param {string} name
 * @param {string} xmluri
 * @param {string} startId
 * @param {object} map
 * @returns {Object}
 */
export function createInstance(name,xmluri,startId,map){
  const inst = createInstanceMapped(name,xmluri,startId,map)
  addChild(document.body,'a',{'class':'colofon',href:'http://iwan.com',target:'iwan',textContent:String.fromCharCode(169)+' Iwan Baan'})
  return inst
}



// WEBPACK FOOTER //
// ./src/js/iwan/basePano.js